/* unplugin-vue-components disabled */import script from "./BlackFilterBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlackFilterBlock.vue?vue&type=script&setup=true&lang=ts"

import "./BlackFilterBlock.vue?vue&type=style&index=0&id=4f24ac9e&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f24ac9e"]])

export default __exports__